import { createContext, useContext } from 'react';

export type MenuSize = 'compact' | 'small' | 'medium' | 'large';

type MenuContext = {
  size: MenuSize;
};

export const MenuContext = createContext<MenuContext | undefined>(undefined);

export const useMenuContext = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error(
      'useMenuContext must be used within a MenuContext (which is available by using MenuTrigger)'
    );
  }
  return context;
};
